export enum WalletStatus {
  RECOVERY_PROGRESS = 'recovery-progress',
  NO_WALLET = 'no-wallet',
  LEGACY_WALLET = 'legacy-wallet',
  NO_SIGNER = 'no-signer',
}
